<template>
  <!-- RB (in-play) -->
  <div id="showtable">
    <template v-if="!selectedMatchAllBet">
      <template v-if="(drawEventList && Object.keys(drawEventList).length > 0)">
        <template v-for="(sportObj, sportObjKey) in drawEventList">
          <div  @click="showSport(sportObjKey)" class="list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card" style="height: 38px !important;" :style="{'top':showFavEvents ? '35.5px':'83.5px'}">
            <div class="list-card-inner">
              <div class="match-type text-left yb-flex-between">
                <div class="col-left">
                  {{ getSportLang(sportObjKey) }}
                  <span class="match-number"></span>
                </div>
              </div>
            </div>
          </div>
  
          <template v-if="showLgeEve[sportObjKey] && !showLgeEve[sportObjKey].hide"> <!-- show sport -->
            <template v-for="(eventObj, eventObjKey) in sportObj">
              <!-- League Capt -->
              <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important;" :style="{'top':showFavEvents ? '73.5px':'121.5px'}">
                <div class="list-card-inner" :key="eventObjKey">
                  <div class="c-match-league match-tpl0-bg" :class="{ 'match-tpl0': !showLgeEve[sportObjKey][eventObjKey].hide, 'leagues-pack': showLgeEve[sportObjKey][eventObjKey].hide }" @click="showLeg(eventObjKey, sportObjKey, false)">
                  <!-- <div class="c-match-league match-tpl0-bg" :class="{ 'match-tpl0': !sortedEventList[sportObjKey][eventObjKey].hide, 'leagues-pack': sortedEventList[sportObjKey][eventObjKey].hide }" @click="showLeg(eventObjKey, sportObjKey, false)"> -->
                  <!-- <div class="c-match-league match-tpl0-bg" :class="{ 'match-tpl0': !sortedEventList[sportObjKey][eventObjKey].hide, 'leagues-pack': sortedEventList[sportObjKey][eventObjKey].hide }" @click="showLeg(eventObjKey, sportObjKey, false)"> -->
                    <div class="tr-match-head">
                      <div class="leagues-wrap"  :style="{ width: (simpleSport==null)? widthColumn[2] + 'px !important':'700px !important' }">
                        <i size="14px" class="icon-arrow q-icon c-icon"></i>
                        <div class="league-icon-wrap">
                          <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                        </div>
                        <div class="ellipsis-wrap">
                          <div class="absolute-full">
                            <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                            <span class="league-match-count">{{ eventObj.length }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="play-name vrow col">
                        <template v-if="sportObjKey == 'N1'">
                          <template v-if="simpleSport!='N1'">
                            <div class="col ellipsis bet-col0">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'] }}
                            </div>
                            <div class="col ellipsis bet-col1">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'] }}
                            </div>
                            <div class="col ellipsis bet-col2">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'] }}
                            </div>
                            <template v-if="selectedLang == 1">
                              <div class="col ellipsis bet-col3">
                                <div class="double-row">
                                  <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2'] }}</div>
                                  <div class="highlight-t">
                                    {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                                  </div>
                                </div>
                              </div>
                              <div class="col ellipsis bet-col4">
                                <div class="double-row">
                                  <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP'] }}</div>
                                  <div class="highlight-t">
                                    {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                                  </div>
                                </div>
                              </div>
                              <div class="col ellipsis bet-col5">
                                <div class="double-row">
                                  <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U'] }}</div>
                                  <div class="highlight-t">
                                    {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                                  </div>
                                </div>
                              </div>
                              <template v-if="isUnfold">
                                <div class="col ellipsis bet-col6" v-if="widthColumn[3]==0">
                                  <div data-v-59e369b2="" class="double-row" >
                                    <div data-v-59e369b2="" class="">Half With </div>
                                    <div data-v-59e369b2="" class=""> Most Goals</div>
                                  </div>
                                </div>
                                <div class="col ellipsis bet-col7">
                                  <div data-v-59e369b2="" class="double-row">
                                    <div data-v-59e369b2="" class="">{{ sportAllBetLang['ALL_BET.LBL_HOME'] }}</div>
                                    <div data-v-59e369b2="" class="">{{ sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL'] }}</div>
                                  </div>
                                </div>
                                <div class="col ellipsis bet-col8">
                                  <div data-v-59e369b2="" class="double-row">
                                    <div data-v-59e369b2="" class="">{{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}</div>
                                    <div data-v-59e369b2="" class="">{{ sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL'] }}</div>
                                  </div>
                                </div>
                                <div class="col ellipsis bet-col9"> 
                                  <div data-v-59e369b2="" class="double-row">
                                    <div data-v-59e369b2="" class="">Both Teams</div>
                                    <div data-v-59e369b2="" class=""> To Scores</div>
                                  </div>
                                </div> 
                                <div class="col ellipsis bet-col10" v-if="widthColumn[3]<2">
                                  <div data-v-59e369b2="" class="double-row">
                                    <div data-v-59e369b2="" class="">To Win</div>
                                    <div data-v-59e369b2="" class=""> From Behind</div>
                                  </div>
                                </div>
                                <div class="col ellipsis bet-col11"> {{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }} </div> 
                                <div class="col ellipsis bet-col12"> {{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }} </div>
                              </template>
                            </template>
                            <template v-else>
                              <div class="col ellipsis bet-col3 highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'] }}
                              </div>
                              <div class="col ellipsis bet-col3 highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'] }}
                              </div>
                              <div class="col ellipsis bet-col3 highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'] }}
                              </div>
                              <template v-if="isUnfold">
                                <div class="col ellipsis bet-col6" v-if="widthColumn[3]==0">{{ sportAllBetLang['ALL_BET.SUBHEADER_HMG'] }}</div>
                                <div class="col ellipsis bet-col7"> {{ sportAllBetLang['ALL_BET.HTG'] }} </div>
                                <div class="col ellipsis bet-col8"> {{ sportAllBetLang['ALL_BET.ATG'] }} </div>
                                <div class="col ellipsis bet-col9">  {{ sportAllBetLang['ALL_BET.SUBHEADER_BTTS'] }}</div> 
                                <div class="col ellipsis bet-col10" v-if="widthColumn[3]<2">  {{ sportAllBetLang['ALL_BET.SUBHEADER_TWFB'] }}  </div>
                                <div class="col ellipsis bet-col11"> {{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }} </div> 
                                <div class="col ellipsis bet-col12"> {{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }} </div>
                              </template>
                            </template>
                          </template>
                        </template>
                        <template v-else-if="sportObjKey == 'G1'">
                          <div class="col">{{ sportAllBetLang['ALL_BET.SUBHEADER_FT_ML'] }}</div>
                          <div class="col">{{ sportAllBetLang['ALL_BET.SUBHEADER_FT_HDP'] }}</div>
                          <div class="col">{{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OU'] }}</div>
                          <div class="col">{{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }}</div>
                        </template>
                        <template v-else>
                          <div class="col">{{ getBetCaption('ML') }}</div>
                          <div class="col">{{ getBetCaption('HDP') }}</div>
                          <div class="col">{{ getBetCaption('OU') }}</div>
                          <div class="col">{{ getBetCaption('OE') }}</div>
                        </template>
                      </div>
                      <div class="yb-flex-center" style="width: 39px !important;">
                        <div class="icon-wrap m-star-wrap-league"
                          :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"
                          @click="favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)">
                          <i class=" icon-star q-icon c-icon"
                            :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- League Events -->
              <template v-if="!showLgeEve[sportObjKey][eventObjKey].hide"> <!-- show league events -->
                <template v-for="(event, eventKey) in eventObj" v-if="eventKey!='hide'">
                  <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid"  :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw', true)" v-if="simpleSport==null">
                    <div class="list-card-inner">
                      <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec', true)">
                        <div class="c-match-item more-handicap csid-1" :class="event.sptid=='1'?'match-tpl0-bg':''">
                          <div class="process-col yb-flex-center">
                            <sportTime :event="event"></sportTime>
                          </div>

                          <div class="match-handicap-item-wrap">
                            <template v-if="sportObjKey=='N1'">
                              <template v-for="(subMatch, subMatchKey) in (event.sub + 1)" v-if="showSubMatch(subMatch, event, subMatchKey)">
                                <div class="match-handicap-item">
                                  <sportTeam :event="event" :issc="true" classes="none" :subMatchKey="subMatchKey" :widthL="widthColumn[0]" :plyType="ftPlyType" :isRB="true"></sportTeam>
                                  <div class="c-match-handicap" :class="sportObjKey!='N1'?'cmh':''" :id="'cmatch'+event.eveid">
                                    <div class="vrow no-wrap">
                                        <!-- FT 1X2 -->
                                        <div class="handicap-col" :id="'handicapCol'+event.eveid+onex2BetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <template v-if="subMatchKey == 0">
                                                    <template
                                                      v-if="event.od[ftPlyType] && event.od[ftPlyType][onex2BetType] && event.od[ftPlyType][onex2BetType]['oddsh']">
                                                      <template v-if="event.sptid=='1' && (selectedLang=='4' || selectedLang=='11')">1</template>
                                                      <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_HOMEWIN'] }}</template>
                                                    </template>
                                                  </template>
                                                </div>
                                              </div>
                                              <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="onex2BetType" />
                                            </div>
                                          </div>
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <template v-if="subMatchKey == 0">
                                                    <template
                                                      v-if="event.od[ftPlyType] && event.od[ftPlyType][onex2BetType] && event.od[ftPlyType][onex2BetType]['oddsa']">
                                                      <template v-if="event.sptid=='1' && (selectedLang=='4' || selectedLang=='11')">2</template>
                                                      <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                                    </template>
                                                  </template>
                                                </div>
                                              </div>
                                              <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="onex2BetType" />
                                            </div>
                                          </div>
                                          <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div
                                                class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0">
                                                      <template
                                                        v-if="event.od[ftPlyType] && event.od[ftPlyType][onex2BetType] && event.od[ftPlyType][onex2BetType]['oddsd']">
                                                        <template v-if="event.sptid=='1' && (selectedLang=='4' || selectedLang=='11')">X</template>
                                                        <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                                      </template>
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="ftPlyType" :betType="onex2BetType" />
                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                        <!-- FT HDP -->
                                        <div class="handicap-col" :id="'handicapCol'+event.eveid+hdpBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <handicap :event="event" :favTeam="'a'" :plyType="ftPlyType" :betType="hdpBetType" :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="hdpBetType"
                                                :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <div class="bet-item-wrap" style=" height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <handicap :event="event" :favTeam="'b'" :plyType="ftPlyType" :betType="hdpBetType" :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="hdpBetType"
                                                :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            </div>
                                          </template>
                                        </div>
                                        <!-- FT OU -->
                                        <div class="handicap-col" :id="'handicapCol'+event.eveid+ouBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more">
                                                  <template v-if="event.od[ftPlyType] && event.od[ftPlyType][ouBetType] && event.od[ftPlyType][ouBetType][getSMKey(subMatchKey)]">
                                                    {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                                  </template>
                                                  &nbsp;
                                                </span>
                                                <div class="handicap-value-text">
                                                  <over-under :event="event" :plyType="ftPlyType" :betType="ouBetType"
                                                    :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="ouBetType"
                                                :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more">
                                                  <template v-if="event.od[ftPlyType] && event.od[ftPlyType][ouBetType] && event.od[ftPlyType][ouBetType][getSMKey(subMatchKey)]">
                                                    {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                                  </template>
                                                  &nbsp;
                                                </span>
                                                <div class="handicap-value-text">
                                                  <over-under :event="event" :plyType="ftPlyType" :betType="ouBetType"
                                                    :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="ouBetType"
                                                :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            </div>
                                          </template>
                                        </div>
                                        <!-- 1H 1X2 -->
                                        <div class="handicap-col" :id="'handicapCol'+event.eveid+onex2BetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <template v-if="subMatchKey == 0">
                                                    <template
                                                      v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][onex2BetType] && event.od[firstHtPlyType][onex2BetType]['oddsh']">
                                                      <template v-if="event.sptid=='1' && (selectedLang=='4' || selectedLang=='11')">1</template>
                                                      <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_HOMEWIN'] }}</template>
                                                    </template>
                                                  </template>
                                                </div>
                                              </div>
                                              <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome"
                                                :plyType="firstHtPlyType" :betType="onex2BetType" />
                                            </div>
                                          </div>
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <template v-if="subMatchKey == 0">
                                                    <template
                                                      v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][onex2BetType] && event.od[firstHtPlyType][onex2BetType]['oddsa']">
                                                      <template v-if="event.sptid=='1' && (selectedLang=='4' || selectedLang=='11')">2</template>
                                                      <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                                    </template>
                                                  </template>
                                                </div>
                                              </div>
                                              <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="firstHtPlyType" :betType="onex2BetType" />
                                            </div>
                                          </div>
                                          <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div
                                                class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0">
                                                      <template
                                                        v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][onex2BetType] && event.od[firstHtPlyType][onex2BetType]['oddsd']">
                                                        <template v-if="event.sptid=='1' && (selectedLang=='4' || selectedLang=='11')">X</template>
                                                        <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                                      </template>
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="firstHtPlyType" :betType="onex2BetType" />
                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                        <!-- 1H HDP -->
                                        <div class="handicap-col" :id="'handicapCol'+event.eveid+hdpBetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <handicap :event="event" :favTeam="'a'" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                <div class="handicap-value-text">
                                                  <handicap :event="event" :favTeam="'b'" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            </div>
                                          </template>
                                        </div>
                                        <!-- 1H OU -->
                                        <div class="handicap-col" :id="'handicapCol'+event.eveid+ouBetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more">
                                                  <template
                                                    v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ouBetType] && event.od[firstHtPlyType][ouBetType][getSMKey(subMatchKey)]">
                                                    {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                                  </template>
                                                  &nbsp;
                                                </span>
                                                <div class="handicap-value-text">
                                                  <over-under :event="event" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            <div
                                              class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                              <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                <span class="handicap-more">
                                                  <template
                                                    v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ouBetType] && event.od[firstHtPlyType][ouBetType][getSMKey(subMatchKey)]">
                                                    {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                                  </template>
                                                  &nbsp;
                                                </span>
                                                <div class="handicap-value-text">
                                                  <over-under :event="event" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey" />
                                                </div>
                                              </div>
                                              <odd :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey"></odd>
                                            </div>
                                          </div>
                                          <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                            </div>
                                          </template>
                                        </div>

                                        <!-- Unfold SC All -->
                                        <template v-if="isUnfold">
                                          <!-- hmg1x2 -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+rhmg1x2BetType+ftPlyType+subMatchKeyCap[subMatchKey]" v-if="widthColumn[3]==0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div
                                                class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0">
                                                      <template
                                                        v-if="event.od[ftPlyType] && event.od[ftPlyType][rhmg1x2BetType] && event.od[ftPlyType][rhmg1x2BetType]['oddsh']">
                                                        {{ lang.sportAllBet['ALL_BET.LBL_1HT'] }}
                                                      </template>
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome"
                                                :plyType="ftPlyType" :betType="rhmg1x2BetType" />
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div
                                                class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0">
                                                      <template
                                                        v-if="event.od[ftPlyType] && event.od[ftPlyType][rhmg1x2BetType] && event.od[ftPlyType][rhmg1x2BetType]['oddsa']">
                                                        {{ lang.sportAllBet['ALL_BET.LBL_2HT'] }}
                                                      </template>
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway"
                                                  :plyType="ftPlyType" :betType="rhmg1x2BetType" />
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                                <div
                                                  class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                  <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                    <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                    <div class="handicap-value-text">
                                                      <template v-if="subMatchKey == 0">
                                                        <template
                                                          v-if="event.od[ftPlyType] && event.od[ftPlyType][rhmg1x2BetType] && event.od[ftPlyType][rhmg1x2BetType]['oddsd']">
                                                          {{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}
                                                        </template>
                                                      </template>
                                                    </div>
                                                  </div>
                                                  <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw"
                                                    :plyType="ftPlyType" :betType="rhmg1x2BetType" />
                                                </div>
                                              </div>
                                            </template>
                                          </div>
                                          <!-- HTG -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+htgBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more">
                                                    <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][htgBetType]">
                                                      {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                                    </template>
                                                    &nbsp;
                                                  </span>
                                                  <div class="handicap-value-text">
                                                    <over-under v-if="subMatchKey == 0" :event="event" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey" />
                                                  </div>
                                                </div>
                                                <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey"></odd>
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more">
                                                    <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][htgBetType]">
                                                      {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                                    </template>
                                                    &nbsp;
                                                  </span>
                                                  <div class="handicap-value-text">
                                                    <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey" />
                                                  </div>
                                                </div>
                                                <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey"></odd>
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                            </template>
                                          </div>
                                          <!-- ATG -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+atgBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more">
                                                    <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][atgBetType]">
                                                      {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                                    </template>
                                                    &nbsp;
                                                  </span>
                                                  <div class="handicap-value-text">
                                                    <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey" />
                                                  </div>
                                                </div>
                                                <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey"></odd>
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more">
                                                    <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][atgBetType]">
                                                      {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                                    </template>
                                                    &nbsp;
                                                  </span>
                                                  <div class="handicap-value-text">
                                                    <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey" />
                                                  </div>
                                                </div>
                                                <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey"></odd>
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                            </template>
                                          </div>
                                          <!-- BTTS -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+bttsBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][bttsBetType] && event.od[ftPlyType][bttsBetType]['oddsh']">
                                                      {{ sportAllBetLang['ALL_BET.LBL_YES'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="bttsBetType" ref="team1" />
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][bttsBetType] && event.od[ftPlyType][bttsBetType]['oddsa']">
                                                      {{ sportAllBetLang['ALL_BET.LBL_NO'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="bttsBetType" ref="team2" />
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                            </template>
                                          </div>
                                          <!-- To Win From Behind -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+rtwfbBetType+ftPlyType+subMatchKeyCap[subMatchKey]" v-if="widthColumn[3]<2">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey==0  && event.od[ftPlyType] && event.od[ftPlyType][rtwfbBetType] && event.od[ftPlyType][rtwfbBetType]['oddsh']">
                                                      {{ sportAllBetLang['ALL_BET.LBL_HOME'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="rtwfbBetType" ref="team1" />
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][rtwfbBetType] && event.od[ftPlyType][rtwfbBetType]['oddsa']">
                                                      {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="rtwfbBetType" ref="team2" />
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                            </template>
                                          </div>
                                          <!-- O/E -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+oeBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0 && event.od[ftPlyType] && event.od[ftPlyType][oeBetType]">
                                                      {{ sportAllBetLang['ALL_BET.LBL_ODD'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="oeBetType" :match="subMatchKey" ref="teamOdd" />
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][oeBetType]">
                                                      {{ sportAllBetLang['ALL_BET.LBL_EVEN'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="oeBetType" :match="subMatchKey" ref="teamEven" />
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                            </template>
                                          </div>
                                          <!-- Clean Sheet -->
                                          <div class="handicap-col" :id="'handicapCol'+event.eveid+rcshBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey==0  && event.od[ftPlyType] && event.od[ftPlyType][rcshBetType] && event.od[ftPlyType][rcshBetType]['oddsh']">
                                                      {{ sportAllBetLang['ALL_BET.LBL_HOME'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="rcshBetType" ref="team1" />
                                              </div>
                                            </div>
                                            <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                              <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                                <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                                  <span class="handicap-more" style="display: none;">&nbsp;</span>
                                                  <div class="handicap-value-text">
                                                    <template v-if="subMatchKey == 0 && event.od[ftPlyType] && event.od[ftPlyType][rcshBetType] && event.od[ftPlyType][rcshBetType]['oddsa']">
                                                      {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}
                                                    </template>
                                                  </div>
                                                </div>
                                                <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="rcshBetType" ref="team2" />
                                              </div>
                                            </div>
                                            <template v-if="subMatchKey == 0">
                                              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                            </template>
                                          </div>
                                        </template>
                                      <!-- </template> -->
                                    </div>
                                  </div>
                                  <div class="media-col" :class="sportObjKey!='N1'?'c-os2':''"  v-if="subMatchKey==0">
                                    <div class="media-col-wrap">
                                      <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                        <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                                      </div>
                                      <div class="yb-flex-center"></div>
                                      <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                                        <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2)" :class="{ active: livetvEveid== event.eveid}" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                            <!-- sub match : Other  -->
                            <template v-else>
                              <template v-for="(subMatch, subMatchKey) in getSubMatchCount(event['od'][getFullTime(event['od'])])" v-if="showSubMatch(subMatch, event, subMatchKey)">
                                <div class="match-handicap-item">
                                  <sportTeam :event="event" :issc="true" classes="none" :subMatchKey="subMatchKey" :widthL="widthColumn[0]" :plyType="ftPlyType" :isRB="false"></sportTeam>
                                  <div class="c-match-handicap cmh" :id="'cmatch'+event.eveid">
                                    <div class="vrow no-wrap">
                                      <!-- FT ML -->
                                      <div class="handicap-col hc-os2" :id="'handicapCol'+event.eveid+mlBetType+getFullTime(event['od'])+subMatchKeyCap[subMatchKey]">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                            <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text"></div>
                                            </div>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="getFullTime(event['od'])" :betType="mlBetType" />
                                          </div>
                                        </div>
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                            <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text"></div>
                                            </div>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="getFullTime(event['od'])" :betType="mlBetType" />
                                          </div>
                                        </div>
                                        <template v-if="subMatchKey == 0">
                                            <div class="bet-item-wrap" style="height: 35px !important;" >
                                            </div>
                                          </template>
                                      </div>
                                      <!-- FT HDP -->
                                      <div class="handicap-col hc-os2" :id="'handicapCol'+event.eveid+hdpBetType+getFullTime(event['od'])+subMatchKeyCap[subMatchKey]">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text">
                                                <handicap :event="event" :favTeam="'a'" :plyType="getFullTime(event['od'])" :betType="hdpBetType" :match="subMatchKey" />
                                              </div>
                                            </div>
                                            <odd :event="event" :team="teamA" :plyType="getFullTime(event['od'])"
                                              :betType="hdpBetType" :match="subMatchKey"></odd>
                                          </div>
                                        </div>
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text">
                                                <handicap :event="event" :favTeam="'b'" :plyType="getFullTime(event['od'])" :betType="hdpBetType" :match="subMatchKey" />
                                              </div>
                                            </div>
                                            <odd :event="event" :team="teamB" :plyType="getFullTime(event['od'])"
                                              :betType="hdpBetType" :match="subMatchKey"></odd>
                                          </div>
                                        </div>
                                        <template v-if="subMatchKey == 0">
                                          <div class="bet-item-wrap" style="height: 35px !important;">
                                          </div>
                                        </template>
                                      </div>
                                      <!-- FT OU -->
                                      <div class="handicap-col hc-os2" :id="'handicapCol'+event.eveid+ouBetType+getFullTime(event['od'])+subMatchKeyCap[subMatchKey]">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more">
                                                <template
                                                  v-if="event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][ouBetType]">
                                                  {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                                </template>
                                                &nbsp;
                                              </span>
                                              <div class="handicap-value-text">
                                                <over-under :event="event" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey" />
                                              </div>
                                            </div>
                                            <odd :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey"></odd>
                                          </div>
                                        </div>
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more">
                                                <template
                                                  v-if="event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][ouBetType]">
                                                  {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                                </template>
                                                &nbsp;
                                              </span>
                                              <div class="handicap-value-text">
                                                <over-under :event="event" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey" />
                                              </div>
                                            </div>
                                            <odd :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey"></odd>
                                          </div>
                                        </div>
                                        <template v-if="subMatchKey == 0">
                                          <div class="bet-item-wrap" style="height: 35px !important;">
                                          </div>
                                        </template>
                                      </div>
                                      <!-- FT OE -->
                                      <div class="handicap-col hc-os2" :id="'handicapCol'+event.eveid+oeBetType+getFullTime(event['od'])+subMatchKeyCap[subMatchKey]">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more">
                                                <template
                                                  v-if="subMatchKey == 0 && event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][oeBetType]">
                                                  {{ sportTableLang.table['SPORT_TABLE.ODD'] }}
                                                </template>
                                                &nbsp;
                                              </span>
                                              <div class="handicap-value-text"></div>
                                            </div>
                                          <!-- <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="oeBetType"
                                                                                            :match="subMatchKey"></odd> -->
                                            <odd v-if="subMatchKey == 0" :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="oeBetType" :match="subMatchKey">
                                            </odd>
                                          </div>
                                        </div>
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more">
                                                <template
                                                  v-if="subMatchKey == 0 && event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][oeBetType]">
                                                  {{ sportTableLang.table['SPORT_TABLE.EVEN'] }}
                                                </template>
                                                &nbsp;
                                              </span>
                                              <div class="handicap-value-text"></div>
                                            </div>
                                            <odd v-if="subMatchKey == 0" :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="oeBetType" :match="subMatchKey">
                                            </odd>
                                          </div>
                                        </div>
                                        <template v-if="subMatchKey == 0">
                                          <div class="bet-item-wrap" style="height: 35px !important;" >
                                          </div>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="media-col c-os2">
                                    <div class="media-col-wrap"  v-if="subMatchKey==0">
                                      <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                        <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }"></div>
                                      </div>
                                      <div class="yb-flex-center"></div>
                                      <!--div class="icon-wrap relative-position">
                                        <div class="v-icon animation-icon"></div>
                                      </div-->
                                      <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                                        <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2)" :class="{ active: livetvEveid== event.eveid}"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                            
                            <moreBetComponent v-if="event.sptid=='1' && chkMoreBetExist(event, true)" :event="event"  :widthColumn="widthColumn"  :isUnfold="isUnfold"></moreBetComponent>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <simpleSoccer :event="event" :isRB="true" :widthColumn="widthColumn" :isUnfold="isUnfold" :firstEventEveid="firstEventEveid" :livetvEveid="livetvEveid" v-else></simpleSoccer>
                </template>
              </template> <!-- END League Events -->
            </template> <!-- END sortedEventList -->

          </template>
        </template>
      </template>
    </template>

    <div class="" v-if="(drawEventList && Object.keys(drawEventList).length > 0)">
      <div style="height: 15px;"></div>
      <div class="pager-wrap vrow justify-end">
        <div class="go-top-btn yb-flex-center" @click="backtoTop">
          <i aria-hidden="true" role="presentation" class="q-icon icon-go_top c-icon" style="font-size: 14px;"></i>
          <div class="vmsg">{{ lang.sportAllBet['ALL_BET.BACK_TOP'] }}</div>
        </div>
      </div>
    </div>
    <div class="absolute-full resize-observer-wrap">
      <div class="absolute-full expand"></div>
      <div class="absolute-full shrink"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'

import sportTime from './sportTimeColumn'
import sportTeam from './sportTeamColumn'
import soccerAllCommon from './soccerAllCommon'
import moreBetComponent from './allBet/more-bet'
import simpleSoccer from './simpleSoccer'

import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    moreBetComponent,
    soccerAllCommon,
    sportTime,
    sportTeam,
    simpleSoccer,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      'sportList',
      'sportIdArr',
      'sortedEventList',
      // 'sortedRBEventList',
      'sortedFavRbEventList',
      'market',
      'selectedShow',
      'selectedMarket',
      'selectedBettype',
      'selectedSport',
      'selectedAllBetNew',
      'selectedMatchAllBet',
      'tvIconFlag',
      'moreBetLoading',
      'favouriteLgeEvents',
      'open_RBMarket',
      'unfold_AllSc',
      'frameWidthHeight',
      'livetv',
      'firstEvent',
      'account',
      'showFavEvents',
      'showLgeEve',
      'simpleSport',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid:{ 
      get() {
        let ft=this.$store.getters.firstEvent
        return Object.keys(ft).length>0 ? ft.eveid:0
      }
    },
    widthColumn: {
      get() {
        var fm = this.$store.getters.frameWidthHeight
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount =fm.leagueTeam.columnCountBet;
        var columnCountBetShow =fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId
        var tmp = this.$store.getters.selectedBettype.tmpltId
        var hideCol=0;
        if(!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]){
          if(pageCenter<=1370){
            columnCountBetShow-=1;
            hideCol+=1;
          }
          if(pageCenter<1280){
            columnCountBetShow-=1;
            hideCol+=1;
          }
          columnCount=columnCountBetShow;
        }
        var AvailableLT = pageCenter-timeColumn-favColumn-(betBoxWidthMin*columnCount)-leagueBoxWidthMin;   
        if(AvailableLT>0){
          let TeamCal = AvailableLT * 0.7;
          team=betBoxWidthMin+(TeamCal/columnCount);
          team= Math.floor(team);
          if(team<betBoxWidthMin){
            team=betBoxWidthMin
          }else if(team>betBoxWidthMax){
            team=betBoxWidthMax;
          }
          let caladd = team-betBoxWidthMin
          if(caladd>0){
            AvailableLT = AvailableLT -((team-betBoxWidthMin)*columnCount)
            if(AvailableLT>0){
              league = AvailableLT+leagueBoxWidthMin
            }
          }else{
            league = AvailableLT+leagueBoxWidthMin
          }
        }else{
          league = AvailableLT+leagueBoxWidthMin
        }
        league=league-15; // minus scroll width + border use
        return [league,team, league+timeColumn,hideCol ] // Team column , team column , league title
      },
    },
    drawEventList: {
		 	get() {
         var vue = this
         var sEve = ''
         var countx = 0
         var lgeArr = _.cloneDeep(this.$store.getters.showLgeEve)

         // rearrange but sport cat
        //  if(!this.showFavEvents){
           var eveArr = _.cloneDeep(this.$store.getters.sortedEventList)
           sEve = eveArr
        //  } else {
        //    var eveArr = _.cloneDeep(this.$store.getters.sortedFavRbEventList)
        //    vue.newEventList = {}
        //     _.forEach(eveArr, function (evedata, key) {
        //     var sprtID = (!_.isUndefined(vue.sportIdArr[evedata[0].sptid])) ? vue.sportIdArr[evedata[0].sptid] : vue.sportIdArr['99']
          
        //     if(!_.isUndefined(vue.newEventList[sprtID])){
        //       vue.newEventList[sprtID].push(evedata)
        //     }else{
        //       vue.newEventList[sprtID] = []
        //       vue.newEventList[sprtID].push(evedata)
        //     }

        //     _.forEach(eveArr, function (dtx, key) {
        //       lgeArr[sprtID] = (_.isUndefined(lgeArr[sprtID])) ? {} : lgeArr[sprtID]
        //       lgeArr[sprtID].hide = (_.isUndefined(lgeArr[sprtID].hide)) ? false : lgeArr[sprtID].hide
        //       lgeArr[sprtID][key] = (_.isUndefined(lgeArr[sprtID][key])) ? {} : lgeArr[sprtID][key]
        //       _.forEach(dtx, function (value, index) {
        //         if(_.isUndefined(lgeArr[sprtID][key].hide)){
        //           lgeArr[sprtID][key].hide = (countx < 2) ? false : true
        //         }
        //         countx++
        //       });
        //     });
        //   })
        //   sEve = vue.newEventList
        //  }
         this.$store.commit('SHOW_LGEEVE', lgeArr)
        
         return sEve
		 	},
		 	set(value) {
         alert('val : '+value)
		 	}
		 },
  },
  watch : {
    unfold_AllSc: {
      handler: function (val, oldVal) {
        this.checkUnfold()
      },
      deep: true
    }
  },
  data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      moreBetEveId: null,
      allSportId: 'G98',
      newEventList: {},
      isUnfold: false,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    }
  },
  beforeMount(){
    this.checkUnfold()

    var vue = this
  },
  mounted() {
    EventBus.$on('moreBetLoading', ((params) => {
      // this.reloadingPer = '75 %';
    }).bind(this))
  },
  methods: {
    getSMKey(smKey){
      var smKeyId = ''
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a'
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b'
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c'
      } else {
        smKeyId = 'd'
      }
      return smKeyId
    },
    checkUnfold(){
      var sprt = this.selectedBettype.sprtId
      var tmp = this.selectedBettype.tmpltId
      if(!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])){
        this.isUnfold = this.unfold_AllSc[sprt][tmp]
      }
    },
    getEvent(eveObj, sport){
      var a = false
      if(eveObj.sptid==this.sportIdArr[sport.sprtId]){
        a = true
      }else if(sport.sprtId=='G2' && ($.inArray(parseInt(eveObj.sptid), [1,2,3,21,12,15]) == -1)){
        a = true
      }
      return a
    },
    getSportLang(sportID){
      var vue = this
      var capt = ''
      _.forEach(vue.sportList, function (sportdata, key) {
        if(sportID == sportdata.sprtId){
          capt = sportdata.sprtLang.replace("<br/>", "")
        }
      })
      
      return capt
    },
    chkSport(eventObj, sportList){
      var vue = this
      var capt = ''
      _.forEach(sportList, function (sportdata, key) {
        if(vue.sportIdArr[eventObj.sptid] == sportdata.sprtId){
          capt = sportdata.sprtLang
        }
      })
      
      return capt
    },
    getBetCaption(bt) {
      return this.sportAllBetLang['ALL_BET.SUBHEADER_FT_' + bt]
    },
    colspanS() {
      // return (this.selectedMarket == 3) ? 2 : 3
      return 2
    },
    showSport(sportKey){
      this.$set(this.showLgeEve[sportKey], 'hide', !this.showLgeEve[sportKey].hide)
    },
    showLeg(key, sportKey, isRB) {
      this.$set(this.showLgeEve[sportKey][key], 'hide', !this.showLgeEve[sportKey][key].hide)
    },
    enterAllBet(event,startTv) {
      this.$store.commit('SHOW_UNFOLD', true)
      this.$store.commit('SHOW_FOLD', false)
      this.$store.commit('UNFOLD_ALLSC', false)
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv=1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: true,
        // isRB: (event.rbinfo) ? true : false,
        token: token.arr_8,
        loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
    },
    enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8,
      })
    },
    backtoTop() {
      // $(".list-scrollbar").animate({ scrollTop: 0 },100);
      $(".sport-table-scroll").animate({ scrollTop: 0 },100);
    },
  },
  updated() {

  },
  beforeDestroy() {
    this.$store.commit('SHOW_LGEEVE', {})
  },
  destroyed() {
    EventBus.$off("moreBetLoading");
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/inPlayCommon.vue